import { MatDialogRef } from '@angular/material/dialog';
import { CompartmentRuleListSearchCriteria, CompartmentRuleListURIParams } from '../../../models';
import { ExportDialogComponent } from '../../../../../../../ui-kit';

export class CompartmentRuleListLoad {
  public static readonly type = '[CompartmentRuleList] Load';
  constructor(public payload: CompartmentRuleListURIParams) {}
}

export class CompartmentRuleListInitialState {
  public static readonly type = '[CompartmentRuleList] Set initial state';
}

export class CompartmentRuleListDownloadStart {
  public static readonly type = '[CompartmentRuleListExport] Start';

  constructor(
    public payload: {
      name: string;
      filterView: Partial<CompartmentRuleListSearchCriteria>;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
      hubId: number;
      compartmentId: number;
    },
  ) {}
}
